import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  CloseVirtualCardCardContentRouteProps,
  closeVirtualCardContentRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectVirtualCardSecureModels } from 'src/redux/selectors/data/virtualCards.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectVirtualCardIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<CloseVirtualCardCardContentRouteProps>(
      location.pathname,
      closeVirtualCardContentRouteProps,
    ) as match<CloseVirtualCardCardContentRouteProps>
    return mtch.params.id
  },
)

export const selectVirtualCard = createSelector(
  [selectVirtualCardSecureModels, selectVirtualCardIdFromRoute],
  (virtualCards, virtualCardId) => {
    return virtualCards[virtualCardId] !== undefined
      ? virtualCards[virtualCardId]
      : undefined
  },
)

export const selectPuttingCloseVirtualCardFromState = (
  state: RootState,
): boolean => state.app.closeVirtualCardContent.puttingCloseVirtualCard

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.closeVirtualCardContent.topLevelError
